import React, {useCallback} from "react";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import ListView from "../../../components/ContentDisplay/ListView";
import {saveSelectedControler} from "../../../redux/Actions/controllers.actions";
import ControllerCard from "./controllerCard";
import {useControllerSearchOptions} from "./useControllersSearchOptions";
import {TABLE_HEADERS} from "./controllersTable.constants";
import {useControllersTableData} from "./useControllersTableData";

const ControllersTable = () => {
  const dispatch = useDispatch();
  const {controllers, handleSearch} = useControllersTableData();
  const {searchOptions} = useControllerSearchOptions();
  const navigate = useNavigate();

  const handleRowSelection = useCallback(
    (selectedRow) => {
      dispatch(saveSelectedControler(selectedRow));
      navigate(`/app/appliance/${selectedRow.mac}`);
    },
    [dispatch, navigate]
  );

  return (
    <div style={{marginTop: "10px"}}>
      <ListView
        listItems={controllers}
        listHeaders={TABLE_HEADERS}
        rowClickable
        onSelectRow={handleRowSelection}
        withSearchQuery={true}
        searchPlaceHolder={"Filter Appliances"}
        searchOptions={searchOptions}
        handleSearch={handleSearch}
        tableName={"location-controller"}
        cardContent={ControllerCard}
        testId={"controller-card"}
      />
    </div>
  );
};

export default ControllersTable;
